import React from 'react';
import { ForgeTooltip } from '@tylertech/forge-react';
import { AI_ICON_NAME } from '../../../static/constants.js';

const SLOT_ATTRIBUTE = 'slot';
const LEADING_SLOT = 'leading';

export const getTooltip = (button) => (
  <ForgeTooltip anchor={button.id} placement="bottom">
    {button.tooltip}
  </ForgeTooltip>
);

export const customForgeListItemRender = (option, listItem) => {
  const textNode = document.createTextNode(option.label || '');
  listItem.appendChild(textNode);

  if (option.useAiIcon) {
    const aiIcon = document.createElement(AI_ICON_NAME);
    aiIcon.setAttribute(SLOT_ATTRIBUTE, LEADING_SLOT);
    aiIcon.className = 'defaultIconSize';
    listItem.appendChild(aiIcon);
  }
};
